import { render, staticRenderFns } from "./volumeWeight.vue?vue&type=template&id=4b4debbb"
import script from "./volumeWeight.vue?vue&type=script&lang=js"
export * from "./volumeWeight.vue?vue&type=script&lang=js"
import style0 from "./volumeWeight.vue?vue&type=style&index=0&id=4b4debbb&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4debbb')) {
      api.createRecord('4b4debbb', component.options)
    } else {
      api.reload('4b4debbb', component.options)
    }
    module.hot.accept("./volumeWeight.vue?vue&type=template&id=4b4debbb", function () {
      api.rerender('4b4debbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/orderList/volumeWeight.vue"
export default component.exports